export const flowsheetExtensions = ["cc7", "cc8", "dwxmz", "dwxml"];
export const dwsimExtensions = ["dwxmz", "dwxml"];
export const generateThumbnailExtensions = ["dwxmz", "dwxml"];
export const excelExtensions = ["xlsx"];

